import React, { useContext, useState } from 'react';
import {injectIntl} from "react-intl";
import Checkbox from "@FormElements/Checkbox";
import FormContext from "formContext";
import axios from "axios";

function ManageYourDataParagraph ({intl}) {
  const {additionalData, showToast, setToastMessage, triggerRerender} = useContext(FormContext);
  const { user } = additionalData;

  const initialStateChecked = user && user.atomeData && user.atomeData.Optin === true || false;
  const [checked, setChecked] = useState(initialStateChecked);
  const [loading, setLoading] = useState(false);

  const handleChange = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    const value = !!event.target.checked
    setChecked(value);
    setLoading(true);

    axios.put(`${process.env.REACT_APP_API_PREFIX}/user/personal-details/`, {
      Optin: value
    }).then((res) => {
      setChecked(JSON.parse(res.config.data).Optin || false);
      const message = intl.formatMessage({id: 'Profile.AccountUpdated.Toast.SuccessMessage'});
      setToastMessage(message);
      showToast();
      triggerRerender();
      setLoading(false);
    }).catch(() => {});
  };

  return (
    <div className="my-environment-item__content mt-xs l:mt-s">
      <div className="form-group form-group--selection-control">
        <Checkbox
          settings={{
            name: 'Optin',
            label: 'AccountSettings.ShareData.Checkbox.Label',
            state: {'Optin': checked},
          }}
          onChange={handleChange}/>
      </div>
    </div>
  );
}

export default injectIntl(ManageYourDataParagraph);